import styled from '@emotion/styled'
import { colors, fontSize, fontWeight, spacing } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'

interface Props {
  text: string
}

const Wrapper = styled.div({
  width: '100px',
  height: '26px',
  backgroundColor: colors.DETRIMENTAL.LIGHT,
  padding: `${spacing.X4} ${spacing.X8}`,
  flexGrow: 0,
  borderRadius: '6px',
  marginRight: '6px',
  marginTop: '6px',
})

const PillText = styled.div({
  color: colors.DETRIMENTAL.REGULAR,
  fontSize: fontSize.X12,
  lineHeight: fontSize.X18,
  fontWeight: fontWeight.SEMIBOLD,
  textAlign: 'center',
})

export const StaffingAlertTimePill: FunctionComponent<Props> = ({ text }) => (
  <Wrapper>
    <PillText>{text}</PillText>
  </Wrapper>
)
